/** @format */

import React, { PureComponent } from 'react';
import compose from 'recompose/compose';
import withStyles from '@material-ui/core/styles/withStyles';
import adescomStyle from '../../assets/jss/adescom/adescomStyle';
import { FormControl } from '@material-ui/core';
import Datetime from 'react-datetime';
import moment, { Moment } from 'moment';
import GridContainer from '../../components/Grid/GridContainer';
import SearchNull from '../../components/Adescom/SearchNull';
import Grid from '@material-ui/core/Grid';
import { FilterReducerFieldName, FilterReducers } from '../filter/FilterReducers';
import { connect } from 'react-redux';

interface EsDateTimeProps {
    dispatch: any;
    classes: any;
    defaultValue?: string;
    fieldName: string;
    dateFormat: string | null;
    clearField?: boolean;
    nullable?: boolean;
    timeFormat?: boolean | string;

    callback(dateTime: string | null, fieldName: string): void;

    searchActionCallback(): void;

    breakLine?: boolean;
    autoComplete?: string;
}

interface EsDateTimeState {
    hasValue: boolean;
    value?: string | number | readonly string[];
}

class EsDateTime extends PureComponent<EsDateTimeProps, EsDateTimeState> {
    constructor(props: EsDateTimeProps, context: EsDateTimeState) {
        super(props, context);
        this.state = {
            hasValue: false,
            value: '',
        };
    }

    componentDidUpdate(prevProps: Readonly<EsDateTimeProps>, prevState: Readonly<EsDateTimeState>, snapshot?: any): void {
        const { clearField, dispatch } = this.props;
        const { hasValue } = this.state;
        if (hasValue && clearField) {
            this.clearInput();
            dispatch({
                type: FilterReducerFieldName.HEADER_FILTER_MANAGE,
            });
        }
    }

    clearInput = (): void => {
        this.setState({
            hasValue: false,
            value: '',
        });
    };

    getFormat = (org: boolean): string => {
        const { dateFormat } = this.props;
        let dateF = 'YYYY-MM-DD HH:mm';
        if (dateFormat) {
            let tmpDateFormat = dateFormat;
            //DateFormat syntax fix
            const timeIndex = dateFormat.indexOf('HH:MM');
            if (timeIndex > -1 && !org) {
                tmpDateFormat = dateFormat.substring(0, timeIndex) + 'HH:mm' + dateFormat.substring(timeIndex + 5);
            }
            //!DateFormat syntax fix

            if (org) {
                dateF = tmpDateFormat;
            } else {
                dateF = tmpDateFormat.replace(/RRRR/gi, 'YYYY');
            }
        }
        return dateF;
    };

    dateTimeCallback = (moment: Moment | string, fieldNameInput: string): void => {
        const { callback, fieldName, dispatch } = this.props;

        if (typeof moment === 'string') {
            if (moment === 'null') {
                this.setState({ value: 'null', hasValue: true }, () => {
                    callback(fieldName, moment);
                    dispatch({
                        type: 'headerFilterManage',
                        headerFilterElementName: fieldName,
                        headerFilterElementHasValue: true,
                    });
                });
            } else {
                if (fieldNameInput === fieldName) {
                    this.setState({ value: moment, hasValue: true }, () => {
                        callback(fieldName, moment);
                    });
                    callback(fieldName, '');
                }
            }
        } else {
            let format = this.getFormat(false);
            if (fieldNameInput === fieldName) {
                format = this.getFormat(false);
                const dateTimeString = moment.format(format);
                this.setState({ value: moment.format(this.getFormat(false)), hasValue: true }, () => {
                    callback(fieldNameInput, dateTimeString);
                });
                dispatch({
                    type: 'headerFilterManage',
                    headerFilterElementName: fieldName,
                    headerFilterElementHasValue: true,
                });
            }
        }
    };

    actionChange = (e: any): void => {
        const { searchActionCallback } = this.props;
        if (e.key === 'Enter' && searchActionCallback) {
            searchActionCallback();
        }
    };

    render():
        | React.ReactElement<any, string | React.JSXElementConstructor<any>>
        | string
        | number
        | {}
        | React.ReactNodeArray
        | React.ReactPortal
        | boolean
        | null
        | undefined {
        const { classes, defaultValue, fieldName, dateFormat, nullable, timeFormat, breakLine, autoComplete } = this.props;
        const { value } = this.state;
        const styleAppendix: { opacity?: string; color?: string; unselectable?: string } = {};
        if (value === 'null') {
            styleAppendix.color = 'rgba(0,0,0,0)';
        }

        const dateF = this.getFormat(true);
        const nowEnd: Moment = moment();
        nowEnd.set({
            hours: 23,
            minutes: 59,
            seconds: 59,
        });

        return (
            <GridContainer style={{ marginRight: nullable ? '40px' : '0' }}>
                {nullable && (
                    <Grid item xs={3}>
                        <SearchNull fieldType={'date-simple'} fieldName={fieldName} updateCallback={this.dateTimeCallback} />
                    </Grid>
                )}
                <Grid item xs={nullable ? 9 : 12} style={{ paddingLeft: nullable ? '0px' : '0px' }}>
                    <FormControl id={'reactDateTime'} className={classes.formControl} style={{ minWidth: '100px' }}>
                        <Datetime
                            autoComplete={autoComplete ?? 'off'}
                            timeFormat={timeFormat}
                            locale="pl"
                            {...this.props}
                            defaultValue={defaultValue || nowEnd}
                            dateFormat={true}
                            onChange={(moment: Moment | string): void => this.dateTimeCallback(moment, fieldName)}
                            inputProps={{
                                id: fieldName,
                                disabled: !!(value && value === 'null'),
                                placeholder: dateF,
                                onKeyPress: this.actionChange,
                                value: value,
                                autoComplete: autoComplete ?? 'off',
                                style: { ...styleAppendix },
                            }}
                        />
                        {breakLine && <br />}
                    </FormControl>
                </Grid>
            </GridContainer>
        );
    }
}

const stateToProps = (state: { filterReducer: FilterReducers }): object => {
    const { filterReducer } = state;
    if (filterReducer && filterReducer.clearAll) {
        return {
            clearField: true,
        };
    }
    return {};
};
export default compose<any, any>(connect(stateToProps), withStyles(adescomStyle))(EsDateTime);
